module.exports = __webpack_public_path__ + "img/e1.6e48edbf.jpg";